import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';

const jwt = new JwtHelperService();

export class User {
    email: string;
    userId: string;
    roles: string[];
}

export class AuthToken {
    exp: number;
    iat: number;
    user: User;
    org: string;

    public isValid(): boolean {
        return moment().isBefore(moment.unix(this.exp || new AuthToken().exp));
    }

    public getValue(): string {
        return this.org;
    }
}

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    private decodedToken: AuthToken;
    private userSubject = new BehaviorSubject<User | null>(null);

    // 公開用 Observable
    user$ = this.userSubject.asObservable();

    constructor() {
        const authMeta = localStorage.getItem('auth_meta');
        if (authMeta == null) {
            this.decodedToken = new AuthToken();
            this.userSubject.next(null);
        } else {
            this.exchange(JSON.parse(authMeta), localStorage.getItem('auth_tkn')!);
        }
    }

    getToken(): AuthToken {
        return this.decodedToken ? this.decodedToken : new AuthToken();
    }

    private exchange(tokenObject: any, token: string) {
        this.decodedToken = new AuthToken();
        this.decodedToken.exp = tokenObject.exp;
        this.decodedToken.iat = tokenObject.iat;
        this.decodedToken.user = tokenObject.user;
        this.decodedToken.org = token;

        this.userSubject.next(this.decodedToken.user ?? null);
    }

    public save(token: string): AuthToken {
        const decoded = jwt.decodeToken(token) as AuthToken || new AuthToken();
        this.exchange(decoded, token);

        localStorage.setItem('auth_tkn', token);
        localStorage.setItem('auth_meta', JSON.stringify(this.decodedToken));

        return this.decodedToken;
    }

    public clear(): void {
        localStorage.removeItem('auth_tkn');
        localStorage.removeItem('auth_meta');
        this.decodedToken = new AuthToken();
        this.userSubject.next(null);
    }

    /** ユーザー情報のみを更新（例: メール変更時） */
    public setUser(user: User): void {
        if (this.decodedToken) {
            this.decodedToken.user = user;
            localStorage.setItem('auth_meta', JSON.stringify(this.decodedToken));
            this.userSubject.next(user);
        }
    }
}
